@import '../styles/palette.scss';
@import '../styles/deviceBreakpoints.scss';

%contentCommon {
  display: flex;
  flex-direction: column;
  height: calc(100% - 4rem);
  position: absolute;
  right: 0;
  top: 4rem; // Height of topbar

  @include target(tablet) {
    height: calc(100vh - 4rem);
    margin-bottom: -0.3rem;
    position: relative;
    top: 0;
  }
}

.content {
  @extend %contentCommon;
  align-items: center;
  left: 13.125rem; // Width of sidebar

  .main {
    margin-left: 5%;
    width: 95%;
  }

  .footer {
    width: 95%;
  }
}

.contentMobile {
  @extend %contentCommon;
  align-items: stretch;
  width: 100%;

  .footer {
    width: 100%;
  }
}

.main {
  flex: 1 0 auto;
}

.footer {
  border-top: 0.1rem solid #e3e4e5;
  flex-shrink: 0;
  height: 4rem;
  margin-top: 1rem;
  padding-top: 1rem;

  nav {
    margin: auto;
    text-align: center;

    .link {
      color: _palette(secondary);
      display: inline-block;
      font-size: 0.8125rem;
      margin: 0 0.75rem;

      &:hover {
        text-decoration: none;
      }
    }
  }
}
